module.exports = __webpack_public_path__ + "static/debiphone.e2d02f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/debiphone.png
// module id = 1260
// module chunks = 35783957827783